import * as React from "react";
import ListSubheader from "@mui/material/ListSubheader";

import { BrandContext } from "../../App";
import { useAuth } from "../../contexts/AuthContext";
import SideMenuButton from "../simple/SideMenuButton";
import { useTheme } from "@mui/material/styles";

export function MainDashboardMenu({ open, toggleMobileMenu }) {
  const theme = useTheme();
  const { trainingProgram, featureFlags } = React.useContext(BrandContext);

  const { loggedInUser } = useAuth();

  return (
    <React.Fragment>
      {loggedInUser && (
        <>
          <ListSubheader
            component="div"
            inset
            sx={{
              color: theme.palette.text.primary,
              display: open ? "block" : "none",
              [theme.breakpoints.up("sm")]: {},
            }}
          >
            {loggedInUser.company && loggedInUser.company.name}
          </ListSubheader>

          {[
            {
              to: "/",
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.66667 14.1663H13.3333M9.18141 2.30297L3.52949 6.6989C3.15168 6.99275 2.96278 7.13968 2.82669 7.32368C2.70614 7.48667 2.61633 7.67029 2.56169 7.86551C2.5 8.0859 2.5 8.32521 2.5 8.80384V14.833C2.5 15.7664 2.5 16.2331 2.68166 16.5896C2.84144 16.9032 3.09641 17.1582 3.41002 17.318C3.76654 17.4996 4.23325 17.4996 5.16667 17.4996H14.8333C15.7668 17.4996 16.2335 17.4996 16.59 17.318C16.9036 17.1582 17.1586 16.9032 17.3183 16.5896C17.5 16.2331 17.5 15.7664 17.5 14.833V8.80384C17.5 8.32521 17.5 8.0859 17.4383 7.86551C17.3837 7.67029 17.2939 7.48667 17.1733 7.32368C17.0372 7.13968 16.8483 6.99275 16.4705 6.69891L10.8186 2.30297C10.5258 2.07526 10.3794 1.9614 10.2178 1.91763C10.0752 1.87902 9.92484 1.87902 9.78221 1.91763C9.62057 1.9614 9.47418 2.07526 9.18141 2.30297Z"
                    stroke="#EAEAEA"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              text: "Home",
              enabled: true,
            },
            trainingProgram?.id && {
              to: `/dashboard/trainingprogram/${trainingProgram.id}`,
              icon: (
                <svg
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.41667 16.6666H4.16667C3.24619 16.6666 2.5 15.9204 2.5 15V3.33329C2.5 2.41282 3.24619 1.66663 4.16667 1.66663H15.8333C16.7538 1.66663 17.5 2.41282 17.5 3.33329V15C17.5 15.9204 16.7538 16.6666 15.8333 16.6666H14.5833M10 15.8333C11.3807 15.8333 12.5 14.714 12.5 13.3333C12.5 11.9526 11.3807 10.8333 10 10.8333C8.61929 10.8333 7.5 11.9526 7.5 13.3333C7.5 14.714 8.61929 15.8333 10 15.8333ZM10 15.8333L10.0179 15.8331L7.35723 18.4938L5.0002 16.1367L7.51638 13.6206M10 15.8333L12.6607 18.4938L15.0177 16.1367L12.5015 13.6206M7.5 4.99996H12.5M5.83333 7.91663H14.1667"
                    stroke="#EAEAEA"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              text: "My Programs",
              enabled: true,
            },
            {
              to: "/dashboard/marketplace",
              icon: (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.99996 17.5L9.91658 17.3749C9.33771 16.5066 9.04828 16.0725 8.66588 15.7582C8.32734 15.4799 7.93726 15.2712 7.51796 15.1438C7.04433 15 6.52255 15 5.47898 15H4.33329C3.39987 15 2.93316 15 2.57664 14.8183C2.26304 14.6586 2.00807 14.4036 1.84828 14.09C1.66663 13.7335 1.66663 13.2668 1.66663 12.3333V5.16667C1.66663 4.23325 1.66663 3.76654 1.84828 3.41002C2.00807 3.09641 2.26304 2.84144 2.57664 2.68166C2.93316 2.5 3.39987 2.5 4.33329 2.5H4.66663C6.53347 2.5 7.46689 2.5 8.17993 2.86331C8.80713 3.18289 9.31707 3.69282 9.63665 4.32003C9.99996 5.03307 9.99996 5.96649 9.99996 7.83333M9.99996 17.5V7.83333M9.99996 17.5L10.0833 17.3749C10.6622 16.5066 10.9516 16.0725 11.334 15.7582C11.6726 15.4799 12.0627 15.2712 12.482 15.1438C12.9556 15 13.4774 15 14.5209 15H15.6666C16.6 15 17.0668 15 17.4233 14.8183C17.7369 14.6586 17.9918 14.4036 18.1516 14.09C18.3333 13.7335 18.3333 13.2668 18.3333 12.3333V5.16667C18.3333 4.23325 18.3333 3.76654 18.1516 3.41002C17.9918 3.09641 17.7369 2.84144 17.4233 2.68166C17.0668 2.5 16.6 2.5 15.6666 2.5H15.3333C13.4665 2.5 12.533 2.5 11.82 2.86331C11.1928 3.18289 10.6828 3.69282 10.3633 4.32003C9.99996 5.03307 9.99996 5.96649 9.99996 7.83333" stroke="#EAEAEA" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ),
              text: "Skills Marketplace",
              enabled: true,
            },
            {
              to: "/dashboard/simulations",
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6667 16.6667V10.8333M10 16.6667V8.33333M3.33337 16.6667L3.33337 13.3333M11.1723 4.18959L15.4793 5.80472M8.99902 4.50077L4.33356 7.99986M17.5506 5.36612C18.0387 5.85427 18.0387 6.64573 17.5506 7.13388C17.0624 7.62204 16.271 7.62204 15.7828 7.13388C15.2947 6.64573 15.2947 5.85427 15.7828 5.36612C16.271 4.87796 17.0624 4.87796 17.5506 5.36612ZM4.21726 7.86612C4.70541 8.35427 4.70541 9.14573 4.21726 9.63388C3.7291 10.122 2.93765 10.122 2.44949 9.63388C1.96134 9.14573 1.96134 8.35427 2.44949 7.86612C2.93765 7.37796 3.7291 7.37796 4.21726 7.86612ZM10.8839 2.86612C11.3721 3.35427 11.3721 4.14573 10.8839 4.63388C10.3958 5.12204 9.60431 5.12204 9.11616 4.63388C8.628 4.14573 8.628 3.35427 9.11616 2.86612C9.60431 2.37796 10.3958 2.37796 10.8839 2.86612Z"
                    stroke="#EAEAEA"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              text: "Performance Spotlight",
              enabled: true,
            },
            {
              to: "/dashboard/conversation-insights",
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_52_94)">
                    <path
                      d="M8.33333 12.5L5.77062 15.0947C5.41315 15.4567 5.23442 15.6376 5.08079 15.6504C4.94751 15.6615 4.81701 15.6079 4.72996 15.5064C4.62963 15.3893 4.62963 15.135 4.62963 14.6263V13.3263C4.62963 12.87 4.25589 12.5397 3.80434 12.4736C2.71145 12.3135 1.85315 11.4552 1.69306 10.3623C1.66667 10.1821 1.66667 9.96709 1.66667 9.53703V5.66666C1.66667 4.26653 1.66667 3.56646 1.93915 3.03168C2.17883 2.56128 2.56128 2.17882 3.03169 1.93914C3.56647 1.66666 4.26653 1.66666 5.66667 1.66666H11.8333C13.2335 1.66666 13.9335 1.66666 14.4683 1.93914C14.9387 2.17882 15.3212 2.56128 15.5608 3.03168C15.8333 3.56646 15.8333 4.26653 15.8333 5.66666V9.16666M15.8333 18.3333L14.0197 17.0724C13.7647 16.8951 13.6372 16.8065 13.4985 16.7437C13.3754 16.6879 13.2459 16.6473 13.113 16.6228C12.9632 16.5952 12.8079 16.5952 12.4974 16.5952H11C10.0666 16.5952 9.59987 16.5952 9.24335 16.4136C8.92974 16.2538 8.67478 15.9988 8.51499 15.6852C8.33333 15.3287 8.33333 14.862 8.33333 13.9286V11.8333C8.33333 10.8999 8.33333 10.4332 8.51499 10.0767C8.67478 9.76307 8.92974 9.5081 9.24335 9.34831C9.59987 9.16666 10.0666 9.16666 11 9.16666H15.6667C16.6001 9.16666 17.0668 9.16666 17.4233 9.34831C17.7369 9.5081 17.9919 9.76307 18.1517 10.0767C18.3333 10.4332 18.3333 10.8999 18.3333 11.8333V14.0952C18.3333 14.8718 18.3333 15.2601 18.2065 15.5664C18.0373 15.9747 17.7129 16.2992 17.3045 16.4684C16.9982 16.5952 16.6099 16.5952 15.8333 16.5952V18.3333Z"
                      stroke="#ffffff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_52_94">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ),
              text: "Conversation Insights",
              enabled: featureFlags?.conversation_insights === true,
            },
            {
              to: "/dashboard/leaderboard",
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_2707_3904)">
                    <path
                      d="M9.99996 12.5003C7.23854 12.5003 4.99996 10.2617 4.99996 7.50033V2.8707C4.99996 2.52582 4.99996 2.35339 5.05022 2.21531C5.13446 1.98384 5.3168 1.8015 5.54828 1.71725C5.68635 1.66699 5.85879 1.66699 6.20366 1.66699H13.7963C14.1411 1.66699 14.3136 1.66699 14.4516 1.71725C14.6831 1.8015 14.8655 1.98384 14.9497 2.21531C15 2.35339 15 2.52582 15 2.8707V7.50033C15 10.2617 12.7614 12.5003 9.99996 12.5003ZM9.99996 12.5003V15.0003M15 3.33366H17.0833C17.4716 3.33366 17.6657 3.33366 17.8189 3.39709C18.0231 3.48167 18.1853 3.6439 18.2699 3.84809C18.3333 4.00123 18.3333 4.19537 18.3333 4.58366V5.00033C18.3333 5.7753 18.3333 6.16279 18.2481 6.48071C18.0169 7.34344 17.3431 8.01731 16.4803 8.24847C16.1624 8.33366 15.7749 8.33366 15 8.33366M4.99996 3.33366H2.91663C2.52834 3.33366 2.3342 3.33366 2.18106 3.39709C1.97687 3.48167 1.81464 3.6439 1.73006 3.84809C1.66663 4.00123 1.66663 4.19537 1.66663 4.58366V5.00033C1.66663 5.7753 1.66663 6.16279 1.75181 6.48071C1.98298 7.34344 2.65685 8.01731 3.51958 8.24847C3.83749 8.33366 4.22498 8.33366 4.99996 8.33366M6.20366 18.3337H13.7963C14.0008 18.3337 14.1666 18.1678 14.1666 17.9633C14.1666 16.3269 12.8401 15.0003 11.2037 15.0003H8.79626C7.15986 15.0003 5.83329 16.3269 5.83329 17.9633C5.83329 18.1678 5.99911 18.3337 6.20366 18.3337Z"
                      stroke="#EAEAEA"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2707_3904">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ),
              text: "Leaderboard",
              enabled: true,
            },
            {
              to: "/dashboard/team",
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3333 17.5V15.8333C18.3333 14.2801 17.271 12.9751 15.8333 12.605M12.9166 2.7423C14.1382 3.23679 15 4.43443 15 5.83333C15 7.23224 14.1382 8.42988 12.9166 8.92437M14.1666 17.5C14.1666 15.9469 14.1666 15.1703 13.9129 14.5577C13.5746 13.741 12.9257 13.092 12.1089 12.7537C11.4963 12.5 10.7198 12.5 9.16663 12.5H6.66663C5.11349 12.5 4.33692 12.5 3.72435 12.7537C2.90759 13.092 2.25867 13.741 1.92036 14.5577C1.66663 15.1703 1.66663 15.9469 1.66663 17.5M11.25 5.83333C11.25 7.67428 9.75758 9.16667 7.91663 9.16667C6.07568 9.16667 4.58329 7.67428 4.58329 5.83333C4.58329 3.99238 6.07568 2.5 7.91663 2.5C9.75758 2.5 11.25 3.99238 11.25 5.83333Z"
                    stroke="#EAEAEA"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              text: "Your Team",
              enabled: true,
            },
          ]
            .filter(Boolean)
            .map(({ to, icon, text, enabled }) => {
              const isHome = to === "/dashboard/home";
              if (!enabled) return;
              return (
                <SideMenuButton
                  key={to}
                  to={to}
                  children={text}
                  startIcon={icon}
                  isHome={isHome}
                  open={open}
                  toggleMobileMenu={toggleMobileMenu}
                />
              );
            })}
        </>
      )}
    </React.Fragment>
  );
}
